import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, Upload } from "lucide-react";
import { Btn, Modal } from "./ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

export const CbamImportButtons = ({ onDone }) => {
  const { t } = useI18n();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const template = async () => {
    const data = await CL.cbamTemplate();
    const url = URL.createObjectURL(new Blob([data]));
    const a = document.createElement("a");
    a.href = url; a.download = "cbam-sablon.xlsx"; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 20000);
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const res = await CL.cbamImport(file);
      setResult(res); onDone();
      toast.success(`${res.created} ${t("importDone")}`);
    } catch (err) { toast.error(err.response?.data?.detail || t("exportError")); }
    finally { setBusy(false); }
  };

  return (
    <>
      <Btn variant="outline" onClick={template} data-testid="cbam-xlsx-template"><FileSpreadsheet className="h-4 w-4" />{t("xlsxTemplate")}</Btn>
      <Btn variant="outline" onClick={() => input.current?.click()} disabled={busy} data-testid="cbam-xlsx-import"><Upload className="h-4 w-4" />{busy ? "..." : t("xlsxImport")}</Btn>
      <input ref={input} type="file" accept=".xlsx" className="hidden" onChange={upload} data-testid="cbam-xlsx-input" />
      <Modal open={!!result} onClose={() => setResult(null)} title={t("importTitle")}
        footer={<Btn onClick={() => setResult(null)} data-testid="cbam-import-close">{t("close")}</Btn>}>
        <p className="text-sm text-[#14512f]" data-testid="cbam-import-created">{result?.created} {t("importDone")}</p>
        {result?.errors?.length > 0 && (
          <div data-testid="cbam-import-errors">
            <div className="mb-2 text-sm font-medium text-[#b4541a]">{t("importErrors")}</div>
            <ul className="max-h-60 space-y-1 overflow-auto text-xs text-[#4b544c]">
              {result.errors.map((er) => <li key={er.row}>{t("importRow")} {er.row}: {er.error}</li>)}
            </ul>
          </div>
        )}
      </Modal>
    </>
  );
};
